module.exports = __webpack_public_path__ + "static/media/si-areogel.ecd998c9.png";